import { gql } from '@sixfold/app-data-framework';

export const sessionViewerQuery = gql`
  query SessionViewer {
    viewer {
      user_id
    }
    sharedViewViewer {
      viewerId
    }
  }
`;
